export default __webpack_public_path__ + "static/Aubry-Lane-740d3859b8f2e0fa11c865b23900fac2.png";